import React from 'react'
import './FilterChip.css'

const FilterChip = ({ label, count, active, onClick }) => {
	const chipClass = active
		? 'filter-chip filter-chip--active flex items-center gap-1.5 px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors bg-indigo-600 text-white'
		: 'filter-chip filter-chip--inactive flex items-center gap-1.5 px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'

	const badgeClass = active
		? 'text-xs px-1.5 py-0.5 rounded-full font-semibold bg-white/25 text-white'
		: count > 0
			? 'text-xs px-1.5 py-0.5 rounded-full font-semibold bg-indigo-50 text-indigo-600'
			: 'text-xs px-1.5 py-0.5 rounded-full font-semibold bg-gray-100 text-gray-400'

	return (
		<button className={chipClass} onClick={onClick}>
			{label}
			{count !== undefined && (
				<span className={badgeClass}>{count}</span>
			)}
		</button>
	)
}

export default FilterChip
